module.exports = __webpack_public_path__ + "static/media/section3.c0dc0ac2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/section3.jpg
// module id = 31
// module chunks = 0